import React, {useMemo} from 'react';
import PropTypes from 'prop-types';

import EventContentWatermarkingForm from '@modules/events/forms/EventContentWatermarking/EventContentWatermarkingForm';
import EventContentWatermarkingModel from '@modules/events/forms/EventContentWatermarking/EventContentWatermarkingModel';
import {createForm} from '@utils/forms';
import {convertToInt} from '@utils/helpers';

const EventWatermarkingEditFormLoader = ({eventId, eventContentWatermarkId}) => {
    const Form = useMemo(() => createForm(
        EventContentWatermarkingModel,
        EventContentWatermarkingForm,
        {
            id: convertToInt(eventContentWatermarkId),
            optionsFetchPolicy: 'no-cache',
            optionsVariables: {
                event: convertToInt(eventId),
            },
        }), [eventId, eventContentWatermarkId]);

    return <Form/>;
};

EventWatermarkingEditFormLoader.propTypes = {
    eventContentWatermarkId: PropTypes.number.isRequired,
    eventId: PropTypes.number.isRequired,
};

EventWatermarkingEditFormLoader.displayName = 'EventWatermarkingEditFormLoader';

export default EventWatermarkingEditFormLoader;
